import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rawmixes_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('rawmixes_token');
      localStorage.removeItem('rawmixes_user');
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (path) => {
  if (!path) return null;
  return `${API}/files/${path}`;
};

export default api;
